module.exports = __webpack_public_path__ + "static/iga-yeni-591ae91f560f78c3da77bd013c089066.png";